import {BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, MuiIcons} from "@leap4/frontend";
import type {GridColDef, GridRenderCellParams} from "@leap4/frontend";
import {OrganizationsBaseUrl} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";
import {Link} from "react-router-dom";
import {RootState} from "../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";

const {Groups: GroupsIcon} = MuiIcons;

const fields = {
    name: 1,
}

const getParams: IGetAllParams = {
    fields
}
let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${OrganizationsBaseUrl}`
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.editOrganization(id)},
        isActive: {},
        updated: {},
        created: {}
    })
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

    const nameCol = columns.find(x => x.field === "name");
    nameCol.renderCell = (params: GridRenderCellParams) => <Link to={urlService.editOrganization(params.id.toString())}><strong>{params.value}</strong></Link>
}

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const OrganizationsDashboardModule = (props:PropsFromRedux) => {
    setStoreAndColumns();

    return (
        <GenericItemsForm
            organization={props.selectedOrganization}
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.organizations(),
                text: "Organizations Dashboard",
                icon: <GroupsIcon />
            }}
            tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
            createButton={{to: "/organization/create", text: "Create Organization"}}
            getAllParams={getParams}

        />
    );
};

export default connector(OrganizationsDashboardModule)